import React, { useEffect } from 'react';
import { Link, Outlet } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo.jsx';
import LanguageToggle from '../components/LanguageToggle.jsx';
import { useBrand } from '../context/TenantContext.jsx';
import { useTranslation } from '../i18n/LanguageContext.jsx';
import '../pages/public/public.css';

/**
 * Shell for the public, no-sign-in pages: the home page (/) and the Privacy
 * Policy (/privacy) and Terms of Service (/terms). Google's OAuth verification
 * needs all three reachable without logging in, which the login split-screen
 * (PublicLayout) is not built for — it is a form shell, not a reading page.
 */
export default function PublicInfoLayout() {
  const brand = useBrand();
  const { t } = useTranslation();

  useEffect(() => {
    document.body.classList.add('public-page');
    return () => document.body.classList.remove('public-page');
  }, []);

  return (
    <div className="public-info">
      <header className="public-info__bar">
        <div className="public-info__inner public-info__bar-inner">
          <Link to="/" className="public-info__brand" aria-label={`${brand.name} — ${t('public.nav.home')}`}>
            <BrandLogo size="sm" variant="dark" />
          </Link>
          <nav className="public-info__nav" aria-label={t('public.nav.label')}>
            <LanguageToggle variant="dark" />
            <Link to="/login" className="btn btn-primary btn-sm" data-testid="public-signin">
              {t('public.nav.signIn')}
            </Link>
          </nav>
        </div>
      </header>

      <main className="public-info__main">
        <Outlet />
      </main>

      <footer className="public-info__foot">
        <div className="public-info__inner public-info__foot-inner">
          <span>© {new Date().getFullYear()} {brand.name}</span>
          <nav className="public-info__foot-links" aria-label={t('public.nav.legal')}>
            <Link to="/privacy" data-testid="footer-privacy">{t('public.nav.privacy')}</Link>
            <Link to="/terms" data-testid="footer-terms">{t('public.nav.terms')}</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
